import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row align-middle mt-3"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "col-12 text-end pl-0" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" })
], -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_5 = { class: "row align-middle mt-2" };
const _hoisted_6 = { class: "col-sm-7 my-auto align-middle pr-0 d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-2" };
const _hoisted_7 = /*#__PURE__*/ _createTextVNode(" | ");
const _hoisted_8 = { class: "col-sm-5 col-12 text-end pl-0" };
const _hoisted_9 = {
    key: 2,
    class: "row align-middle mt-3"
};
const _hoisted_10 = { class: "col-12 text-start pl-0 mb-3" };
const _hoisted_11 = { class: "col-12 text-end pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$tc('homePage.Titel')
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$host.config.loginMethods, (method) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (method.beginGroup)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                        : _createCommentVNode("", true),
                    (method.name === 'user')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("form", null, [
                                _createVNode(_component_g_text_field, {
                                    dataObject: _ctx.$data,
                                    dataMember: "userName",
                                    label: _ctx.$tc('account.UserNameEMail') + '*',
                                    mode: "email",
                                    "data-mode": "model",
                                    "show-clear-button": false,
                                    onEnterKey: _ctx.runLogin
                                }, null, 8, ["dataObject", "label", "onEnterKey"]),
                                _createVNode(_component_g_text_field, {
                                    dataObject: _ctx.$data,
                                    dataMember: "password",
                                    label: _ctx.$tc('account.Password') + '*',
                                    mode: "password",
                                    "data-mode": "model",
                                    onEnterKey: _ctx.runLogin,
                                    autocomplete: "on"
                                }, null, 8, ["dataObject", "label", "onEnterKey"]),
                                (_ctx.hasError)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", null, [
                                        _createVNode(_component_router_link, {
                                            to: "/login/recovery",
                                            tabindex: "-1"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$tc('account.ForgotPassword')), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_7,
                                        _createVNode(_component_router_link, {
                                            to: "/login/register",
                                            tabindex: "-1"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$tc('account.Register')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_g_button, {
                                        text: _ctx.$tc('account.Login'),
                                        "is-loading": _ctx.isLoading,
                                        disabled: _ctx.disableLogin,
                                        onClick: _ctx.runLogin
                                    }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                                ])
                            ])
                        ], 64))
                        : (method.name === 'azureadconnect')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$tc('client.Identity.AzureAdConnect.Notes')), 1),
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_g_button, {
                                        text: _ctx.$tc('client.Identity.AzureAdConnect.LoginButton'),
                                        class: "w-100",
                                        onClick: _ctx.runOIDC
                                    }, null, 8, ["text", "onClick"])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                ], 64));
            }), 256))
        ]),
        _: 1
    }, 8, ["title"]));
}
